import { render, staticRenderFns } from "./LayoutWizardAdvertisement.vue?vue&type=template&id=008f33c8"
import script from "./LayoutWizardAdvertisement.js?vue&type=script&lang=js&external"
export * from "./LayoutWizardAdvertisement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports